import { Bookmark20Px } from "@locaisolutions/icons";

import { Button } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

import { MaintenanceFlagModal } from "./MaintenanceFlagModal";

export const FlagBinButton = ({
  portId,
  disabled
}: {
  portId: number;
  disabled: boolean;
}) => {
  const { t } = useTranslation();
  const trackedPageName = useMixpanelPageName();
  const [isFlagBinModalOpen, setIsFlagBinModalOpen] = useState(false);
  return (
    <>
      <Button
        variant="subtle"
        size="large"
        startIcon={<Bookmark20Px style={{ opacity: disabled ? 0.25 : 1 }} />}
        onClick={() => {
          setIsFlagBinModalOpen(true);
          mixpanelTrack({
            type: "Button Click",
            label: "Flag Bin",
            trackedPageName
          });
        }}
        disabled={disabled}
      >
        {t("flag bin")}
      </Button>
      <MaintenanceFlagModal
        isOpen={isFlagBinModalOpen}
        onClose={() => setIsFlagBinModalOpen(false)}
        portId={portId}
      />
    </>
  );
};
